export const GeneralTypes = {
    SHOW_LOADING : "SHOW_LOADING",
    HIDE_LOADING : "HIDE_LOADING",
}
